import { useContext, useEffect } from 'react';
import logger from 'loglevel';
import { getEnvironmentConstant } from './utilities';
import EnvContext from './envContext';

import { ENVIRONMENT, LOG_LEVEL } from './constants';

const useLogger = () => {
  const envContext = useContext(EnvContext);
  const env = envContext[ENVIRONMENT];

  useEffect(() => {
    const level = getEnvironmentConstant({ key: LOG_LEVEL, env });
    logger.setLevel(level);
  }, [env]);

  return logger;
};

export { useLogger };

export default logger;
